"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vClickOutside = require("v-click-outside");

var _vClickOutside2 = _interopRequireDefault(_vClickOutside);

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  directives: {
    clickOutside: _vClickOutside2.default.directive
  },
  props: ["placeholder", "items", "color", "backgroundColor", "iconColor", "icon", "name", "initialValue", "includeNoneValue", "fontSize", "disabled", "resetOnClick", "dropdownBorder"],

  data: function data() {
    return {
      isShow: false,
      selected: this.getSelected()
    };
  },


  mixins: [_input2.default],

  watch: {
    selected: function selected() {
      this.$emit("change", this.selected);
      this.$emit("input", this.selected);
    }
  },

  computed: {
    classes: function classes() {
      var baseClasses = ["clearfix"];

      baseClasses.push(this.inputTextColorClass);

      if (this.backgroundColor) {
        baseClasses.push("has-background-" + this.backgroundColor);

        if (this.backgroundColor === "input-color-for-blue-background") {
          baseClasses.push("icn-dropdown-placeholder");
        }
      }

      if (this.isShow) {
        baseClasses.push("dropdown-emulator--opened");
      }

      return baseClasses;
    },
    menu: function menu() {
      var baseClasses = [];
      if (this.isShow) {
        baseClasses.push("is-show");
      } else {
        baseClasses.push("no-show");
      }
      baseClasses.push(this.inputTextColorClass);
      baseClasses.push("has-border-top-" + this.inputTextColor);

      if (this.backgroundColor) {
        if (this.backgroundColor === "input-color-for-blue-background") {
          baseClasses.push("has-background-input-blue-dark-accent");
        } else {
          baseClasses.push("has-background-" + this.backgroundColor);
        }
      }

      if (this.dropdownBorder) {
        baseClasses.push("icn-dropdown-border");
      }
      return baseClasses;
    },
    setIconColor: function setIconColor() {
      return this.inputIconColorClass;
    }
  },
  methods: {
    onDropdownItemSelected: function onDropdownItemSelected(item) {
      this.selected = item;
      this.$emit("selected", this.selected);

      if (this.resetOnClick) {
        this.selected = {};
      }
    },
    onClickOutside: function onClickOutside() {
      this.isShow = false;
    },
    getSelected: function getSelected() {
      var _this = this;

      var selected = this.items.filter(function (item) {
        return item.id === _this.initialValue && _this.initialValue !== undefined;
      })[0];

      return selected ? selected : {};
    },
    isSelectedEmpty: function isSelectedEmpty() {
      return _.isEqual({}, this.selected);
    },
    isItemsIncludesSelected: function isItemsIncludesSelected() {
      var _this2 = this;

      return !!this.items.find(function (item) {
        return item.name === _this2.selected.name;
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/IconDropdownField.vue
// module id = xjVE
// module chunks = 0 1